import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const smartfyTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.smartfy,
  logoUrl: "https://cdn.nemuru.com/assets/logos/smartfy-logo.svg",
  palette: {
    primary: {
      main: "#000",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#898989",
      contrastText: "#fff",
    },
    text: {
      title: "#000000",
      primary: "#444",
      secondary: "#666",
    },
    info: {
      light: "#eef5fd",
      main: "#36a3f7",
      dark: "#08404d",
      contrastText: "#ffffff",
    },
    warning: {
      light: "#fefbf3",
      main: "#ffca28",
      contrastText: "#ffffff",
    },
    error: {
      light: "#fbefee",
      main: "#ef5957",
      contrastText: "#ffffff",
    },
    success: {
      light: "#f1faf1",
      main: "#4dd970",
      dark: "#43b46f",
      contrastText: "#ffffff",
    },
    // additional colors
    dark: {
      main: "#3c3b39",
      accent: "#000",
      contrastText: "#ffffff",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#4dd970",
      approved: "#43b46f",
      analysing: "#2ea3f2",
      sent: "#1c69d4",
      cancelled: "#d8d8d8",
      denied: "#dc0723",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#fff",
  customBorderRadius: {
    button: 5,
    paper: 8,
    chip: 100,
  },
};
